import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import styles from './styles.module.scss';
import clsx from 'clsx';

type Props = Omit<BaseButtonProps, 'isSelected'> & {
    isSelected?: boolean;
    variant?: 'default' | 'gray';
};

export const SecondaryFloorButton = ({ children, isSelected = false, variant = 'default', className, ...props }: Props & { className?: string }) => {
    return (
        <BaseButton
            {...props}
            className={clsx(styles['secondary-floor-button'], className, {
                [styles['secondary-floor-button--selected']]: isSelected,
                [styles['secondary-floor-button--gray']]: variant === 'gray',
            })}
        >
            {children}
        </BaseButton>
    );
};
